import { BaseService } from "@/api/services/baseService";
import request from "@/api";
import type { Login, ValidatePhone } from "@/entity/login";
import type { UserVo } from "@zhihaoscm/entity";

export class LoginService extends BaseService<Login, UserVo, unknown, unknown> {
    public async getUserInfo(): Promise<UserVo> {
        const { data } = await this.service.get(`${this.path}/me`);
        return data;
    }

    public async loginPhone(params: ValidatePhone): Promise<{ accessToken: string }> {
        const { data } = await this.service.post(`${this.path}/mobile`, params);
        return data;
    }

    public async enterpriseWeChatLogin(params: { code: string; source?: string; url?: string }) {
        const { data } = await this.service.get(`${this.path}/wxw`, { params });
        return data;
    }
}

export const loginService = new LoginService("/admin/login", request.service);
